var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.019 0C.748-.001.489.097.299.272a.87.87 0 0 0 0 1.312L9.54 9.998.298 18.412a.87.87 0 0 0 0 1.311c.19.177.45.277.72.277.272 0 .532-.1.72-.277l9.964-9.07a.87.87 0 0 0 0-1.311L1.739.272A1.058 1.058 0 0 0 1.019 0Z",
    fill: "#484848",
    fillRule: "nonzero"
  })));
};
export default SvgArrowRight;